import {ActionType} from '../../../components/AutoForm/AutoFieldNew';
import {hasSpecificAnswer} from '../../../components/Wizard/operators';
import {WizardField} from '../../../components/Wizard/QuestionWrapper';
import {AccountBasicFragment} from '../../../schema-types/AccountBasicFragment';

import {ReviewDetailsFragment} from '../../../schema-types/ReviewDetailsFragment';
import {precursorAndHeaderFieldsType} from './precursorFields';
import {
  skippingAnnualReview,
  skippingAnnualReview as skipReviewQuestions,
} from './reviewAction';

export const REVIEW_FOCUS_TYPES = {
  Holistic: 'Holistic',
  Focused: 'Focused',
  XO: 'XO',
};

const getBlock = (
  account: AccountBasicFragment,
  reviewDetails: ReviewDetailsFragment
): WizardField<precursorAndHeaderFieldsType>[] => {
  const fields: WizardField<precursorAndHeaderFieldsType>[] = [
    {
      id: 'isReviewFocused',
      title: 'Is the review focused?',
      question: 'Is the review focused?',
      label: '',
      enabled: (values) => !skippingAnnualReview(values, reviewDetails),
      initialValue: reviewDetails?.focus === REVIEW_FOCUS_TYPES.Focused ? 'Yes' : 'No', // * Review should default to focus false (holistic)
      type: ActionType.buttonGroup,
      requireSubmit: true,
      options: [
        {
          value: 'Yes',
          label: 'Yes',
        },
        {
          value: 'No',
          label: 'No',
        },
      ],
    },
    {
      id: 'reviewFocus',
      title: 'Review Focus',
      question: 'Please select the review focus',
      label: 'Review Focus',
      enabled: hasSpecificAnswer<precursorAndHeaderFieldsType>('isReviewFocused', 'Yes'),
      type: ActionType.select,
      options: [
        {
          value: 'Protection',
          label: 'Protection',
        },
        {
          value: 'Retirement planning',
          label: 'Retirement planning',
        },
        {
          value: 'Investments',
          label: 'Investments',
        },
        {
          value: 'Consolidation',
          label: 'Consolidation',
        },
      ],
      requireSubmit: true,
      initialValue: reviewDetails.focus ?? undefined,
    },
    {
      id: 'name',
      title: 'Review name',
      question: 'What is the name for this review?',
      label: 'Review name',
      enabled: (values) =>
        !skipReviewQuestions(values, reviewDetails) &&
        reviewDetails.reviewType !== 'Annual',
      type: ActionType.text,
      requireSubmit: true,
      initialValue: reviewDetails.name?.replace(/undefined/gi, '') || '',
    },
  ];

  return fields;
};
export default getBlock;
